import {
  ACTION_CREATE_CERTIFICATE__REQUEST,
  ACTION_CREATE_CERTIFICATE__SUCCESS,
  ACTION_CREATE_CERTIFICATE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_CERTIFICATE__REQUEST:
    case ACTION_CREATE_CERTIFICATE__SUCCESS:
      return null;

    case ACTION_CREATE_CERTIFICATE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
